<template>
    <div class="ds-month-shifts-panel">
        <div class="ds-month-shifts-panel-body">
            <h2 class="ds-month-shifts-panel-title">Очистить график на месяц</h2>
            <div class="flex flex-col gap-1.5">
                <span class="ds-glass-label">Месяц</span>
                <MonthSwitcher @date="onDate" />
            </div>
            <div class="flex flex-col gap-1.5">
                <span class="ds-glass-label">Сотрудники</span>
                <dropdown v-model="employment" :options="employments">
                    {{ scheduleStore.cutStr(employment.name, 23) }}
                </dropdown>
            </div>
        </div>
        <div class="ds-month-shifts-panel-footer">
            <button type="button" class="ds-glass-btn ds-glass-btn-secondary ml-auto" @click="emit('close')">Отмена</button>
            <button type="button" class="ds-glass-btn ds-glass-btn-primary" :disabled="isDisabled" @click="clean">Очистить</button>
        </div>
    </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import { Ref, ref, computed } from 'vue'
import utc from "dayjs/plugin/utc"
import MonthSwitcher from './MonthSwitcher.vue'
import { useScheduleStore } from '@/stores/scheduleStore'
import { useAuthStore } from '@/stores/authStore'
import { useToast } from 'vue-toast-notification'

const toast = useToast({ position: 'bottom-right' })

const scheduleStore = useScheduleStore()
const authStore = useAuthStore()

dayjs.extend(utc)
const emit = defineEmits(['close'])

const isDisabled = ref(true)
const start = ref()
const end = ref()
const employments = computed(() => {
    return [{id: null, name: 'Все' }, ...scheduleStore.schedules.filter(sch => !sch.is_vacancy).map(schedule => {
    const name = schedule.user.last_name + ' ' + schedule.user.first_name
    return {id: schedule.id, name}
})]
})
const employment = ref(employments.value[0]) 

const onDate = (date: Ref) => {
    start.value = date.value.startOf('month').format('YYYY-MM-DD')
    end.value = date.value.endOf('month').format('YYYY-MM-DD')
    isDisabled.value = dayjs().isAfter(date.value.startOf('month'))
}

const clean = async () => {
    emit('close')
    if(authStore.permissions?.can_create_schedule) {
        const data = {
        date_from: start.value,
        date_to: end.value,
        department_id: scheduleStore.currentDepartment?.id,
        employment_id: employment.value.id
    }
    await scheduleStore.scheduleCleanup(data)
    } else {
        toast.success('У вас нет прав на данное действие')
    }
}
</script>
